var doc_just_loaded = true;

$(document).ready(function () {
	bindStopOnError("5500");
	// initializeTosValidation();
	// initializeZipValidation();
	initializeOnChangeValidation();
	initializeTosMallPayValidation();
	initializePhysicalPrepaidsSelect();
	initializeFaqOpening();
	ititializePrepaidStartChange();
	initializePrepaidStartChangeDetail();
	initializeRegisterForm();
	initializeMicrositeBuyPrepaids()
	initializeAjaxClearCart();

	initializeTabSwitcher();

	initInfoBar();

	$('#click-el-vydani').click(function () {
		$('#elektronicke-vydani-tab').trigger('click');
	});

	//    if(isMobile()) {
	//        $('#readerDesktop').remove();
	//    } else {
	//        $('#readerMobile').remove();
	//    }

	/*$('a[data-toggle="tab"]').on('shown.bs.tab', function (event) {
		if ($(this).attr('id') == "elektronicke-vydani-tab") {
			$("#detailapp").show();
		} else {
			$("#detailapp").hide();
		}
	});*/

	// faq
	var hash = window.location.hash;
	var anchor = $('a[href$="' + hash + '"]');
	if (anchor.length > 0) {
		anchor[0].click();
	}

	// mobile nav
	/*$(".js-nav-button").click(function () {
		//$(".js-search-button").click();
		if ($(this).hasClass('show')) {
			resetControlButton();
			$(".header__navigation").hide();
			$(this).removeClass("show");

			$(".col--search").hide();
			$(".js-search-button").removeClass("show");
		} else {
			resetControlButton();
			$(".header__navigation").show();
			$(this).addClass("show");

			$(".col--search").show();
			$(".js-search-button").addClass("show");
		}
	});*/

	// mobile search
	/*$(".js-search-button").click(function () {
		if ($(this).hasClass('show')) {
			resetControlButton();
			$(".col--search").hide();
			$(this).removeClass("show");
		} else {
			resetControlButton();
			$(".col--search").show();
			$(this).addClass("show");
		}
	});*/

	// login/selfcare
	/*$("#login, #selfcare").click(function () {
		resetControlButton();
	});*/

	// sidebar navigation button
	/*if ($(document).width() <= 991) {
		$(".sidebar__btn").click(function () {
			$(this).toggleClass('show');
			$("#" + $(this).data('nav')).toggle();
		});
	}*/

	/*if (typeof $.fn.select2 !== 'undefined') {
		$('.js-select-one').select2({
			//placeholder: "",
			//allowClear: true,
			width: '100%',
			minimumResultsForSearch: -1,
		});
	}*/

	initializeVariants();
	initializeMessages();
	initializeRemoveAdultContent();
	initSubscriptionModals();
});

// reset mobile control button
/*function resetControlButton() {
	if ($(document).width() <= 991) {
		$(".js-nav-button").removeClass('show');
		$(".header__navigation").hide();
	}

	if ($(document).width() <= 767) {
		$(".js-search-button").removeClass('show');
		$(".col--search").hide();
	}
}*/


/*function isMobile() {
	return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
}/*


// dropdowns
/*$(function () {
	$('.dropdown').on({
		"click": function (event) {
			if ($(event.target).closest('.dropdown-toggle').length) {
				$(this).data('closable', true);
			} else {
				$(this).data('closable', false);
			}
		},
		"hide.bs.dropdown": function (event) {
			hide = $(this).data('closable');
			$(this).data('closable', true);
			return hide;
		}
	});
});*/
/*    $('.dropdown-hover').hover(function() {
		$('.dropdown-toggle', this).trigger('click');
	});

$('.dropdown').hover(function() {
	if (!($(this).hasClass('open'))) {
		$('.dropdown-toggle', this).trigger('click');
	}
}, function() {
	if ($(this).hasClass('open')) {
		$('.dropdown-toggle', this).trigger('click');
	}
});*/

function initializeTabSwitcher() {
	var hash = window.location.hash;
	if (hash === '#elektronicka-vydani') {
		$('#elektronicke-vydani-tab').trigger('click');
	} else if (hash === '#tistena-vydani') {
		$('#tistene-vydani-tab').trigger('click');
	}
}

var initializeMicrositeBuyPrepaids = function () {
	$('.js-microsice-prepaid_date-from').change(function () {
		ancestor = $(this).closest('article');
		button = $('.add-to-cart', ancestor);
		ei = button.data('extend_info');
		option = $('option:checked', $(this));
		ei["start_date"] = option.data("start_date");
		ei["start_date_friendly"] = option.data("start_date_friendly");
		ei["projectId"] = option.val();
		button[0].dataset["extend_info"] = JSON.stringify(ei);
		button.data('extend_info', ei);
	});

	$('.js-microsice-prepaid_select').change(function () {
		ancestor = $(this).closest('article');
		button = $('.add-to-cart', ancestor);
		counter = $('input[name="counter"]', ancestor);
		price = $('.item__price', ancestor);
		c_type = button.data('c_type')
		option = $('option:checked', $(this));
		button.data("ident", option.val());
		button.attr("data-ident", option.val());
		button.data("key", option.data('key'));
		button.attr("data-key", option.data('key'));
		counter.data("key", option.data('key'));
		counter.attr("data-key", option.data('key'));
		price.html(Math.trunc(option.data('price')) + "&nbsp;Kč");
		if (c_type == "physical_prepaid") {
			ei = button.data('extend_info');
			ei["custom_code"] = option.data("custom_code");
			ei["gift_image_friendly"] = option.data("gift_image_friendly");
			ei["gift_solar_id"] = option.data("gift_solar_id");
			ei["gift_title_friendly"] = option.data("gift_title_friendly");
			button.data('extend_info', ei);
		}
	});
}

function physicalPrepaidSelected(inp) {
	row = inp.closest('.js-physical-prepaid-row');
	details = $(row).find('.js-physical-prepaid-selected-detail');

	$('.js-physical-prepaid-row').removeClass('is--active');
	row.addClass('is--active');

	$('.js-physical-prepaid-selected-detail').not(details).slideUp(300);
	details.slideDown(300, function () {
		// scroll to selected
		$('html,body').animate({ scrollTop: inp.offset().top - 13 }, 500);
	});

	// PREVENT v pripade PREPAID_PERDAY
	if ($('input#prepaid_perday:checked').length === 1) {
		if (
			$('input[type=hidden][name=selected_start_perday]').val() === "" ||
			$('input[type=hidden][name=selected_start_perday]').val() === $('input[type=hidden][name=start_perday]').val()
		) {
			details.find('input.js-closest-date').click();
		} else {
			details.find('input.js-custom-date').click();
		}
	} else if ($('input#prepaid_special:checked').length === 1) {
		if (
			$('input[type=hidden][name=selected_start_special]').val() === "" ||
			$('input[type=hidden][name=selected_start_special]').val() === $('input[type=hidden][name=start_special]').val()
		) {
			details.find('input.js-closest-date').click();
		} else {
			details.find('input.js-custom-date').click();
		}
	} else {
		details.find('input.js-closest-date').click();
	}
}

// hook do buy.js abych vyřešil co potřebuju
function processChangeCartFactoryPortalPreFunction(response, changed_item) {
	if (!changed_item) {
		return;
	}
	if (changed_item.content_type == "physical_prepaid") {
		// na detailu udělat multiple buy_buttons pro fyzicka předplatná
		var buttons = $("button.js--button-prepaid-buy.add-to-cart", $("#tistene-vydani"));
		if (buttons) {
			[].forEach.call(buttons, switchCartButtonToBuy);
		}
	}
	else if (changed_item.content_type == "emag_prepaid") {
		// na detailu udělat multiple buy_buttons pro fyzicka předplatná
		var buttons = $("button.js--button-prepaid-buy.add-to-cart", $("#elektronicke-vydani"));
		if (buttons) {
			[].forEach.call(buttons, switchCartButtonToBuy);
		}
	}
}

function initializePhysicalPrepaidsSelect() {

	var physical_tab = $("#tistene-vydani-tab");
	if (physical_tab) {
		physical_tab.click(function () {
			$('.js-show-for-physical-prepaids').show();
			$('.js-show-for-digital-prepaids').hide();
		})
	}

	var digital_tab = $("#elektronicke-vydani-tab");
	if (digital_tab) {
		digital_tab.click(function () {
			$('.js-show-for-physical-prepaids').hide();
			$('.js-show-for-digital-prepaids').show();
		})
	}

	/*var dis_checkboxes = $('input:disabled[name="prepaid"][data-content_type!="cnc_calendar"][data-content_type!="magazine_special"]');
	if (dis_checkboxes) {
		dis_checkboxes.each(function () {
			$(this).parent().click( function () {
				alert("Aktuálně máte zakoupené předplatné. Předplatné můžete prodloužit nejdříve 5 dní před jeho vypršením");
			})
		})
	} */
}

/*function showPriceAndEnableBuyButton() {
	var price = $('#js-detail-price');
	var buy_button = $('.js-detail-buy-button');
	$(price).show();
	$(buy_button).prop('disabled', false);
}*/

/* autoopen FAQ */
function initializeFaqOpening() {
	if ($('#faq').length > 0 && window.location.hash) {
		var info_block = $(window.location.hash);
		if (info_block) {
			var row = info_block.closest('.faq__item');
			row.find('.faq__tit a').click();
			$('html, body').animate({
				scrollTop: row.offset().top
			}, 800);
		}

	}
}


function initializeTosMallPayValidation() {
	$('input[name="payment_id"]').change(function () {
		var tos = $('.js-mallpay-tos-block');
		if ($('input[name="payment_id"][value="cnc_mallpay"]').is(":checked")) {
			$('#facturation_phone_needed').collapse('show');
			$('#facturation_full_address').attr('data-required', "true");
			$('#facturation_name').attr('data-required', "true");
			$('#facturation_name').attr('data-mandatory_if', "add_facturation_addressr");
			$('#facturation_surname').attr('data-required', "true");
			$('#facturation_surname').attr('data-mandatory_if', "add_facturation_addressr");
			$('#facturation_phone').attr('data-required', "true");
			$('#facturation_phone').attr('data-mandatory_if', "add_facturation_addressr");
			$('#facturation_phone').next().next().show();
			$('input', tos).attr('data-required', "true");
			tos.show();
			if ($('#add_facturation_addressr').length > 0) {
				if (!$('#add_facturation_addressr').is(':checked')) {
					$('#add_facturation_addressr').click();
					$('#add_facturation_addressr').prop("checked", true);
				}
				if (!$('input[name="facturation_phone"]').is(":visible")) {
					$('.js--toggle-shpping-data-form').trigger("click");
					$('#formdata').collapse('hide');
					$('#formdataedit').collapse('show');
				}
				$('.js--mallpay-addr-needed-alert').show();
			}
		}
		else {
			$('#facturation_phone_needed').collapse('hide');
			$('#facturation_full_address').attr('data-required', "false");
			$('#facturation_name').attr('data-required', "false");
			$('#facturation_name').removeAttr('data-mandatory_if')
			$('#facturation_surname').attr('data-required', "false");
			$('#facturation_surname').removeAttr('data-mandatory_if')
			$('#facturation_phone').attr('data-required', "false");
			$('#facturation_phone').next().next().hide();
			$('#facturation_phone').removeAttr('data-mandatory_if')
			$('input', tos).attr('data-required', "false");
			$('.js--mallpay-addr-needed-alert').hide();
			tos.hide();
			if ($('#add_facturation_addressr').is(':checked') && !doc_just_loaded) {
				$('#add_facturation_addressr').click();
				$('#add_facturation_addressr').prop("checked", false);
				if (doc_just_loaded) doc_just_loaded = False;
			}
		}
	});
	$('#payment_selection_mallpay').trigger('change');
}

function initializeOnChangeValidation() {
	$('.js-validate-on-change').focusin(function () {
		unmark_invalid(this, undefined, false);
	});
	$('.js-validate-on-change').blur(function () {
		check_one_form_field(this);
	});
}

function ititializePrepaidStartChange() {
	$('.prepaid-cart-change-date').on('change', function () {

		var req = new XMLHttpRequest();
		req.onreadystatechange = function () {
			// readyState OPENED
			if (req.readyState === 1) {
				document.body.classList.add("loading");
				// readyState HEADERS_RECEIVED
			} else if (req.readyState === 2) {
				document.body.classList.remove("loading");
			}
			else if (req.readyState === XMLHttpRequest.DONE) {
				if (req.status !== 200) {
					alert(req.message);
				}
			}
		};
		var args = {
			new_issue_start: $(this).val(),
			prepaid_id: $(this).data('item_id')
		};
		req.open("POST", "/ajax/change_cart_prepaid_date", true);
		req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
		// serialize je definovaná v login.js
		req.send(serialize(args));
		return false;
	});
}

function initializePrepaidStartChangeDetail() {
	$('.js--gift_harmonogram').on('change', function () {
		sel_option = $(this).find(":selected");
		row = $(this).closest('.prepaid-row');
		btn = $('.js--button-prepaid-buy', row);
		ei = btn.data("extend_info");
		ei["projectId"] = sel_option.attr("value");
		ei["start_date"] = sel_option.data("start_date");
		ei["start_date_friendly"] = sel_option.data("start_date_friendly");
		btn.data("extend_info", ei);
		btn.attr("data-extend_info", JSON.stringify(ei));
		if (btn.hasClass("in-cart")) {
			switchCartButtonToBuy(btn[0]);
		}
	});
}



/*function countProperties(obj) {
	var count = 0;

	for (var prop in obj) {
		if (obj.hasOwnProperty(prop))
			++count;
	}

	return count;
}*/

/*********************************** PER DAY PREPAID **************************/
var ppd = new PrepaidPerDay();
if ($('.prepaid-row.js-prepaid_perday').length > 0) {
	ppd.load();
}

function PrepaidPerDay() {
	this.params = {
		provider: "vydani",
		publication_id: $('input[type=hidden][name=perday_ident]').val(),
		start: $('input[type=hidden][name=start_perday]').val(),
		prepaid_length: "",
		selected_days: [],
		projectId: $('input[type=hidden][name=selected_issue_perday]').val()
	};
	this.load = function () {
		const that = this;
		$('.prepaid__alert').hide();
		that.gatherParams();
		that.resolveBuyButton();

		if (!$('input[type=hidden][name=selected_issue_perday]').val()) {
			var startSelectedElem = $('.js-select-date_perday option:selected');
			$('input[type=hidden][name=selected_issue_perday]').val(startSelectedElem.val());
			$('input[type=hidden][name=start_perday]').val(
				startSelectedElem.data("custom")
			).data(
				"nice", startSelectedElem.text()
			).trigger("change");
		}

		that.bind();
	},
		this.bind = function () {
			const that = this;

			$('select[name=prepaid_length_perday]').on('change', function (e) {
				that.params["prepaid_length"] = $('select[name=prepaid_length_perday] option:selected').val();
				that.params["publication_id"] = $('select[name=prepaid_length_perday] option:selected').data("product_id");

				that.resolveFavorable();
				that.resolveBuyButton();
			});

			$('input[name=selected_days_perday]').on('click', function (e) {
				const checked = $('input[name=selected_days_perday]:checked').map(function (index, input) {
					return input.value;
				}).get().join(',');

				that.params["selected_days"] = checked.split(',');

				that.resolveFavorable();
				that.resolveBuyButton();
				that.resolveStartDays();
			});

			$('.js-select-date_perday').on('change', function (e) {
				var startSelectedElem = $('.js-select-date_perday option:selected');
				that.params["projectId"] = startSelectedElem.val();
				$('input[type=hidden][name=selected_issue_perday]').val(startSelectedElem.val());
				$('input[type=hidden][name=start_perday]').val(
					startSelectedElem.data("custom")
				).data(
					"nice", startSelectedElem.text()
				).trigger("change");
			});

			$('input[type=hidden][name=start_perday]').change(function (e) {
				if ($('input[type=hidden][name=start_perday]').val() !== "") {
					that.params["start"] = $('input[type=hidden][name=start_perday]').val();

					if ($('select[name=prepaid_length_perday] option:selected').val() !== "" && $('input[name=selected_days_perday]:checked').length > 0) {
						that.makeRequest();
					}
				}
			});

			this.resolveFavorable();

			setTimeout(function () {
				if ($('input[type=hidden][name=selected_start_perday]').val() !== "") {
					$('.js-physical-prepaid-inp#prepaid_perday:checked').prop('checked', false);
					$('.js-physical-prepaid-inp#prepaid_perday').trigger('click');
				}

				that.resolveBuyButton();
			}, 200);
		},
		this.makeRequest = function () {
			const that = this;

			let data = {
				"start_date": "",
				"start_date_friendly": "",
				"prepaid_perday": {
					"length": that.params["prepaid_length"],
					"days": that.params["selected_days"],
					"count": "",
					"ident": that.params["publication_id"],
					"projectId": that.params["projectId"]
				}
			};

			var btn = this.getButton();

			$.ajax({
				url: '/ajax/prepaid_perday',
				data: this.params,
				method: 'POST',
				async: true,
				success: function (response) {
					if (response) {
						$('.perday__price .prepaid__price span').text(response.total_price);
						if (Object.keys(response.days).length === 0 && response.days.constructor === Object) {
							$('.js-prepaid_perday .badge__count').text(0);
							$('.js-prepaid_perday .badge.badge--grey')
								.prop('title', "0 čísel")
								.attr('data-original-title', "0 čísel");
						}
						else {
							// const sumEditions = sumOfObjectValues(response.days);
							const sumEditions = response.days;
							$('.js-prepaid_perday .badge__count').text(sumEditions);
							$('.js-prepaid_perday .badge.badge--grey')
								.prop('title', sumEditions + 'čísel')
								.attr('data-original-title', sumEditions + 'čísel');
						}

						var inp = $('input[type=hidden][name=start_perday]');
						data["start_date"] = inp.val();
						data["start_date_friendly"] = inp.data("nice");

						data["prepaid_perday"]["count"] = response.days;
						btn.data('c_type', $('input#prepaid_perday').data('content_type'));
						btn.data('ident', data["prepaid_perday"]["ident"]);
						btn.data('part', data["prepaid_perday"]["ident"]);
						btn.data('extend_info', btoa(JSON.stringify(data)));

						that.resolveFavorable();
					}
				}
			});
		},
		this.resolveFavorable = function () {
			var btn = this.getButton();
			if (
				$('input[name=selected_days_perday]:checked').length == $('input[name=selected_days_perday]').length &&
				$('select[name=prepaid_length_perday] option:selected').val() !== ""
			) {
				$('.js-prepaid_perday .prepaid__alert').show();
				btn.prop('disabled', true);
			} else {
				$('.js-prepaid_perday .prepaid__alert').hide();
				btn.prop('disabled', false);
			}
		},
		this.resolveStartDays = function () {
			var harm = $('.js-prepaid_perday select[name="gift_harmonogram"]');
			$('option', harm).prop("disabled", true);
			$('option', harm).hide();
			$('input[name=selected_days_perday]:checked').each(function () {
				$('option[data-dow="' + $(this).data("dow") + '"]', harm).show();
				$('option[data-dow="' + $(this).data("dow") + '"]', harm).prop('disabled', false)
			})
			//$('option:first', harm).prop('disabled', false);
			//$('option:first', harm).show();
			var fist_enabled_option = $('option[value!=""]:not(:disabled):first', harm);
			if (!$('option:selected', harm).is(":enabled")) {
				fist_enabled_option.prop('selected', true);
			}
		},
		this.gatherParams = function () {
			const checked = $('input[name=selected_days_perday]:checked').map(function (index, input) {
				return input.value;
			}).get().join(',');

			this.params["selected_days"] = checked.split(',');
			if ($('select[name=prepaid_length_perday] option:selected').val()) {
				this.params["prepaid_length"] = $('select[name=prepaid_length_perday] option:selected').val();
				this.params["publication_id"] = $('select[name=prepaid_length_perday] option:selected').data("product_id");
			}
			else {
				this.params["prepaid_length"] = $('select[name=prepaid_length_perday] option:first').val();
				this.params["publication_id"] = $('select[name=prepaid_length_perday] option:first').data("product_id");
			}
		},
		this.selectedCorrect = function () {
			return $('input[name=selected_days_perday]:checked').length > 0
				&& $('input[type=hidden][name=start_perday]').val() !== "";
		},
		this.getButton = function () {
			// row = $('.prepaid-row.js-prepaid_perday');
			// btn = $('.js--button-prepaid-buy', row);
			return $(".prepaid-row.js-prepaid_perday button.add-to-cart");
		},
		this.resolveBuyButton = function () {
			var bButton = this.getButton();
			if (bButton.hasClass("in-cart")) {
				switchCartButtonToBuy(bButton[0]);
			}
			if (this.selectedCorrect()) {
				bButton.removeAttr("disabled");
				this.makeRequest();
			} else {
				bButton.prop('disabled', 'disabled');
				$('.js-prepaid_perday .prepaid__price span').html("-");
			}
		}
};

/********************* SPECIAL PREPAID *************************************/
var spp = new SpecialPrepaid();
if ($('.prepaid-row.js-prepaid_special').length > 0) {
	spp.load();
}

function SpecialPrepaid() {
	this.params = {
		provider: "vydani",
		publication_id: "",
		start: "",
		prepaid_length: "",
		selected_days: [],
		projectId: ""
	};
	this.load = function () {
		const that = this;
		$('.prepaid__alert').hide();
		that.bind();

		that.resolveBuyButton();
	},
		this.bind = function () {
			const that = this;

			$('#prepaid_length_special').on('change', function () {
				sel_option = $(this).find(":selected");

				var btn = that.getButton();
				var ei = btn.data("extend_info");
				ei["prepaid_perday"]["length"] = sel_option.val();
				ei["prepaid_perday"]["publication_id"] = sel_option.data("product_id");
				btn.data("extend_info", ei);
				that.resolveBuyButton();
			});

			$('#special_harmonogram').on('change', function () {
				sel_option = $(this).find(":selected");
				var btn = that.getButton();
				var ei = btn.data("extend_info");
				ei["projectId"] = sel_option.val();
				ei["start_date"] = sel_option.data("custom");
				ei["start_date_friendly"] = sel_option.data("start_date_friendly");
				btn.data("extend_info", ei);
				btn.attr("data-extend_info", JSON.stringify(ei));
				that.resolveBuyButton();
			});
		},
		this.makeRequest = function () {
			const that = this;

			var btn = that.getButton();

			let data = btn.data("extend_info");
			this.params = {
				"provider": "vydani",
				"publication_id": data["prepaid_perday"]["ident"],
				"start": data["start_date"],
				"prepaid_length": data["prepaid_perday"]["length"],
				"selected_days": data["prepaid_perday"]["days"],
				"projectId": data["prepaid_perday"]["projectId"]
			};
			btn.data("c_type", "physical_prepaid");
			btn.data("ident", data["prepaid_perday"]["ident"]);
			btn.data("part", data["prepaid_perday"]["ident"]);

			$.ajax({
				url: '/ajax/prepaid_perday',
				data: this.params,
				method: 'POST',
				async: true,
				success: function (response) {
					if (response) {
						$('.special__price span').text(response.total_price);
						if (Object.keys(response.days).length === 0 && response.days.constructor === Object) {
							$('.js-prepaid_special .badge__count').text(0);
							$('.js-prepaid_special .badge.badge--grey')
								.prop('title', "0 čísel")
								.attr('data-original-title', "0 čísel");
						}
						else {
							const sumEditions = response.days;
							$('.js-prepaid_special .badge__count').text(sumEditions);
							$('.js-prepaid_special .badge.badge--grey')
								.prop('title', sumEditions + 'čísel')
								.attr('data-original-title', sumEditions + 'čísel');
						}

						data["prepaid_perday"]["count"] = response.days;
						btn.data('extend_info', data);
						btn.attr('data-extend_info', JSON.stringify(data));

					}
				}
			});
		},
		this.selectedCorrect = function () {
			return true;
		},
		this.getButton = function () {
			row = $('.prepaid-row.js-prepaid_special');
			btn = $('.js--button-prepaid-buy', row);
			return btn
		},
		this.resolveBuyButton = function () {
			var bButton = this.getButton();
			if (bButton.hasClass("in-cart")) {
				switchCartButtonToBuy(bButton[0]);
			}
			if (this.selectedCorrect()) {
				bButton.removeAttr("disabled");
				this.makeRequest();
			} else {
				bButton.prop('disabled', 'disabled');
				$('.js-prepaid_special .prepaid__price span').html("-");
				$('#js-detail-price .js-detail-price').text(0);
			}
		}
};


/*function sumOfObjectValues(obj) {
	let sum = 0;
	for (let el in obj) {
		if (obj.hasOwnProperty(el)) {
			sum += parseFloat(obj[el]);
		}
	}
	return sum;
}*/

// infobar
function initInfoBar() {
	document.querySelectorAll('.js-infobar-close').forEach(function (element) {
		element.addEventListener('click', function (ev) {
			ev.preventDefault();

			var req = new XMLHttpRequest();
			req.onreadystatechange = function () {
				if (req.readyState === XMLHttpRequest.DONE) {
					if (req.status === 200) {
						var req_data = JSON.parse(req.responseText);
						if (req_data.status === 200) {
							// remove item id-{ident}
							var item = document.getElementById("infobar-" + ident);
							if (item) {
								item.remove();
							}
						} else {
							console.error("Chyba potvrzení skrytí info bar", req_data);
						}
					}
				}
			};

			var ident = this.dataset.ident;
			req.open("GET", "/ajax/infobar_hide/" + ident, true);
			req.send();
			return false;
		});
	});
}

/* GA4 item view check */

function isElementInViewport(el) {

	if (typeof el === "undefined") return false;
	if (typeof jQuery === "function" && el instanceof jQuery) {
		el = el[0];
	}

	var rect = el.getBoundingClientRect();

	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
		rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
	);
}

function ga4ItemHandler() {
	for (i = 0; i < ga4ItemViews.length; i++) {
		if (ga4ItemViews[i]) {
			var el = $(ga4ItemViews[i][0]);
			if (el.length && isElementInViewport(el)) {
				window.dataLayer.push(ga4ItemViews[i][1])
				ga4ItemViews[i] = null
			}
		}
	}
}

if (window.dataLayer) {
	window.ga4ItemViews = window.ga4ItemViews || [];
	$(window).on('load resize scroll', ga4ItemHandler);
}


// REGISTRACE

function initializeRegisterForm() {
	var frm = document.forms["register"];
	if (!frm || !frm.ico || !frm.phone) {
		return;
	}
	frm.ico.addEventListener("input", function (evt) {
		var icoEl = frm.ico;
		var company = frm.buy_company;
		validateFormIco(icoEl, company.checked);
		return true;
	});
	frm.buy_company.addEventListener("change", function (evt) {
		if (evt.target.checked) {
			frm.ico.setAttribute("required", "required");
			frm.phone.setAttribute("required", "required");
		} else {
			frm.ico.removeAttribute("required");
			frm.phone.removeAttribute("required");
			frm.ico.value = "";
			frm.phone.value = ''
		}
		return true;
	});

	frm.phone.addEventListener("input", function (evt) {
		phoneEl = evt.target;
		var company = frm.buy_company;
		validateFormPhone(phoneEl, company.checked)
		return true;
	});
}

function validateFormPhone(phoneEl, isCompany) {
	wrapEl = phoneEl.parentNode.parentNode;
	msisdn = phoneEl.value;
	regex = new RegExp(phoneEl.dataset["regexp"]);

	function phoneValid(errMessage) {
		phoneEl.dataset["valid"] = true;
		wrapEl.classList.remove("has-error");
		phoneEl.classList.remove("is-invalid");
		phoneEl.classList.add("is-valid");
	}

	function phoneInvalid(errMessage) {
		phoneEl.dataset["valid"] = false;
		wrapEl.classList.add("has-error");
		phoneEl.classList.add("is-invalid");
		phoneEl.classList.remove("is-valid");
	}

	var valid = false;
	if (!msisdn) {
		if (!isCompany)
			phoneValid();
		else
			phoneInvalid();
		return
	} else {
		if (regex.test(msisdn))
			phoneValid();
		else
			phoneInvalid();
		return
	}

}

function validateFormIco(icoEl, isCompany) {
	var ico = icoEl.value;
	wrapEl = icoEl.parentNode.parentNode;
	infoEmptyEl = icoEl.parentNode.querySelector(".js-ares-info-empty");
	infoCompanyEl = icoEl.parentNode.querySelector(".js-ares-info-company");
	errEl = icoEl.parentNode.querySelector(".invalid-feedback");
	function icoInvalid(errMessage) {
		icoEl.dataset["valid"] = false;
		wrapEl.classList.add("has-error");
		icoEl.classList.add("is-invalid");
		icoEl.classList.remove("is-valid");
		infoEmptyEl.style.display = "block";
		infoCompanyEl.style.display = "none";
		if (!errMessage) {
			errMessage = icoEl.dataset["invalidtext"];
		}
		errEl.textContent = errMessage;
	}
	function icoValid(company, addr1, addr2) {
		icoEl.dataset["valid"] = true;
		wrapEl.classList.remove("has-error");
		icoEl.classList.remove("is-invalid");
		icoEl.classList.add("is-valid");
		if (!company) {
			infoEmptyEl.style.display = "block";
			infoCompanyEl.style.display = "none";
		} else {
			infoEmptyEl.style.display = "none";
			infoCompanyEl.querySelector(".js-ares-name").textContent = company;
			infoCompanyEl.querySelector(".js-ares-row-one").textContent = addr1;
			infoCompanyEl.querySelector(".js-ares-row-two").textContent = addr2;
			infoCompanyEl.style.display = "block";
		}
	}
	if (!ico) {
		if (!isCompany)
			icoValid();
		else
			icoInvalid();
		return;
	}
	else {
		if (isCompany && ico.length != 8) {
			icoInvalid();
			return;
		}
	}


	var req = new XMLHttpRequest();
	req.onreadystatechange = function () {
		// readyState OPENED
		if (req.readyState === 1) {
			document.body.classList.add("loading");
			// readyState HEADERS_RECEIVED
		} else if (req.readyState === 2) {
			document.body.classList.remove("loading");
		}
		else if (req.readyState === XMLHttpRequest.DONE) {
			if (req.status !== 200) {
				console.error("Request error", req);
				icoInvalid();
				return;
			}

			try {
				var data = JSON.parse(req.responseText);
			} catch (err) {
				console.error(err.message + " in " + req.responseText);
				icoInvalid();
				return;
			}

			if (data.status !== 200) {
				console.error("Response json error" + req.responseText);
				icoInvalid();
				return;
			}

			if (Object.keys(data.company).length == 0) {
				console.error("No comapny for ico found");
				icoInvalid();
				return;
			}
			var city = data.company.mainAddress.city;
			if (data.company.mainAddress.cityDistrict) {
				if (data.company.mainAddress.cityDistrict.startsWith(city)) {
					city = data.company.mainAddress.cityDistrict;
				} else {
					city = city + " - " + data.company.mainAddress.cityDistrict;
				}
			} else if (data.company.mainAddress.cityPart) {
				if (data.company.mainAddress.cityPart.startsWith(city)) {
					city = data.company.mainAddress.cityPart;
				} else {
					city = city + " - " + data.company.mainAddress.cityPart;
				}
			}
			street = (data.company.mainAddress.street == undefined) ? data.company.mainAddress.cityPart : data.company.mainAddress.street;
			icoValid(
				data.company.companyName,
				street + " " + data.company.mainAddress.streetNumber,
				data.company.mainAddress.postalCode + " " + city,
			);
		}
	};
	req.open("GET", "/ajax/solar_get_company_info?ic=" + ico, true);
	req.send();
}

/*function initializeGallery() {
	$('img.js--change_detail_image').on('click', function () {
		$('img.js--detail_main_image').attr('src', $(this).data('detail_main_image_source'));
	});
}*/

function compare_variants(a, b) {
	if ($(a).data('variant_order') < $(b).data('variant_order')) {
		return -1;
	}
	if ($(a).data('variant_order') > $(b).data('variant_order')) {
		return 1;
	}
	return 0;
}

function initializeVariants() {
	$('.js--variant_option').on('click', function () {
		// zmenim tridu active
		var selector = $(this).closest('.js--variant_selector');
		$('.js--variant_option', selector).removeClass('active');
		$(this).addClass('active');

		// slozim dohromady kod varianty
		var variant_code = $('.js-detail-buy-button').data('ident');
		selected_options = $(".js--variant_option.active").sort(compare_variants);
		selected_options.each(function () {
			variant_code += '_' + $(this).data('variant_name') + '#' + $(this).data('variant_value');
		});

		// zmenim obrazek
		$('img.js--detail_main_image').attr('src', variant_images[variant_code]);

		// nastavim variantu pro buy button
		// $('.js-detail-buy-button').data('variant', variant_code);
		// $('.js-detail-buy-button').attr('data-variant', variant_code);

		// zobrazim spravny buybutton a radek s cenou
		$('.js-variant-price-row').hide();
		$('.js-variant-price-row[variant="' + variant_code + '"]').show();
	});
}


// NAKUP NA FIRMU / FA UDAJE

var fa_checkbox = document.getElementById("fa-company");
var fa_name = document.getElementById("fa-name");
var fa_alert = document.getElementById("fa-address-alert");
var fa_address_hint = document.getElementById("facturation_full_address");
var fa_address_manual = document.getElementById("billing_address_manual");
if (fa_address_manual) {
	fa_address_manual = fa_address_manual.getElementsByTagName('input');
}
var fa_address_manual_country = document.getElementById("facturation_country");

function isCompany() {
	if (fa_checkbox.checked == true) {
		if (fa_name)
			fa_name.classList.add("d-none");
		if (fa_alert)
			fa_alert.classList.remove("d-none");
		if (fa_address_hint) {
			fa_address_hint.readOnly = true;
			fa_address_hint.placeholder = "";
		}
		if (fa_address_manual_country) {
			fa_address_manual_country.disabled = true;
			for (var input of fa_address_manual) {
				input.readOnly = true;
			}
		}
	} else {
		if (fa_name)
			fa_name.classList.remove("d-none");
		if (fa_alert)
			fa_alert.classList.add("d-none");
		if (fa_address_hint) {
			fa_address_hint.readOnly = false;
			fa_address_hint.placeholder = fa_address_hint.getAttribute('data-placeholder');
		}
		if (fa_address_manual_country) {
			fa_address_manual_country.disabled = false;
			for (var input of fa_address_manual) {
				input.readOnly = false;
			}
		}
	}
}

if (fa_checkbox) {
	isCompany();

	fa_checkbox.addEventListener('change', (event) => {
		isCompany();
	});
}




// detail gallery popup
if (typeof $.fn.magnificPopup !== 'undefined') {
	$('.js-detail-gallery').magnificPopup({
		delegate: 'a',
		type: 'image',
		gallery: {
			enabled: true,
			tPrev: 'Předchozí',
			tNext: 'Další',
			tCounter: '%curr% / %total%',
		},
		image: {
			tLoading: 'Načítání...',
			tError: 'Obrázek nelze načíst.',
		}
	});
}

function initializeMessages() {
	$('.js--message-opened').on('shown.bs.collapse', function () {
		var notification_id = $(this).data("message_id");
		var aria_id = $(this).attr("id");
		$('.js--message-opened[id!="' + aria_id + '"]').collapse('hide');
		$.ajax({
			url: '/ajax/mark_message_read/' + notification_id,
			data: null,
			method: 'GET',
			async: true,
			success: function (response) {
				if (response && response.status == 200) {
					$('a[aria-controls="' + aria_id + '"]').addClass('marked--read');
				}
			}
		});
	});
}

function load_harmonogram4medium(rate_card_id, since, to) {
	var harmonogram = [];
	$.ajax({
		type: 'POST',
		url: '/ajax/load_prepaid_projects',
		data: {
			rate_card_id: rate_card_id,
			date_since: since,
			date_to: to
		},
		success: function (data) {
			harmonogram = data;
		},
		dataType: "json",
		async: false
	});
	return harmonogram;
};

function load_subscription_deliveries(subscription_id, rate_card_id, date_since, date_to) {
	var deliveries = [];
	$.ajax({
		type: 'POST',
		url: '/ajax/load_prepaid_deliveries',
		data: {
			subscription_id: subscription_id,
			rate_card_id: rate_card_id,
			date_since: date_since,
			date_to: date_to
		},
		success: function (data) {
			deliveries = data;
		},
		dataType: "json",
		async: false
	});
	return deliveries;
};

function initSubscriptionModals() {
	// suspend subscription
	$('.js--suspend-subscription').on('click', function () {
		$('#suspend_from_project option').remove();
		$('#suspend_to_project option').remove();
		$('#modal_prepaid_cancel span.js--modal_subscription_name').html($(this).data('subscription_name'));
		$('#suspension_subscription_id').val($(this).data('subscription_id'));
		var today = new Date();
		var harm = load_harmonogram4medium(
			$(this).data('rate_card_id'),
			(today.toISOString().substring(0, 10) > $(this).data('subscription_from')) ? today.toISOString().substring(0, 10) : $(this).data('subscription_from'),
			$(this).data('subscription_to')
		);
		for (let i = 0; i < harm.length; i++) {
			issue_date = new Date(harm[i]['projectDate']);
			cz_date = issue_date.toLocaleDateString('cz-CS');
			from_option = $('<option>', {
				value: harm[i]['projectId'],
				text: (i == 0) ? 'Ihned' : cz_date
			})
			$(from_option).data('isodate', harm[i]['projectDate']);
			$('#suspend_from_project').append(from_option);

			to_option = $('<option>', {
				value: harm[i]['projectId'],
				text: (i == harm.length - 1) ? 'Na stálo' : cz_date
			})
			to_option.data('isodate', harm[i]['projectDate']);
			$('#suspend_to_project').append(to_option);
		}
		opt_count = $('#suspend_to_project option').length;
		$('#suspend_to_project').prop('selectedIndex', opt_count - 1);
	});

	$('#subscription_suspend_submit_button').on('click', function () {

		// validate data
		iso_start = $('#suspend_from_project option:selected').data('isodate');
		iso_end = $('#suspend_to_project option:selected').data('isodate');
		if (iso_start > iso_end) {
			alert("Začátek přerušení musí být dříve než konec!");
			return false;
		}

		// prepare data
		qry_args = {
			subscription_id: $('#suspension_subscription_id').val(),
			suspension_reason: $('#suspension_reason').val(),
			project_from: $('#suspend_from_project option:selected').val(),
			project_to: $('#suspend_to_project option:selected').val(),
		}

		// submit request
		var req = new XMLHttpRequest();
		req.onreadystatechange = function () {
			if (req.readyState == XMLHttpRequest.DONE) {
				// close modal
				$('#modal_prepaid_cancel').modal('hide');
				data = JSON.parse(req.responseText);
				// show result modal
				if (data.status == 200) {
					$('#modal_prepaid_submited').modal('show');
				} else {
					$('#modal_prepaid_submit_failed').modal('show');
				}
			}
		};

		req.open("POST", "/ajax/suspend_prepaid", true);
		req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
		req.send(jQuery.param(qry_args));
		return true;
	});

	$('.js--check_enable_submit_address_change').on('change', function () {
		// console.log($('#new_delivery_name').val());
		// console.log($('#new_delivery_full_address').val());
		// console.log($('#new_delivery_address_ruian').val());
		can_submit = (
			$('#new_delivery_name').val() != '' &&
			$('#new_delivery_full_address').val() != ''
		);
		if (can_submit) {
			$('#subscription_change_address_submit_button').prop('disabled', false);
		} else {
			$('#subscription_change_address_submit_button').prop('disabled', true);
		}
	});

	// change address for subscription
	$('.js--change-address-subscription').on('click', function () {
		$('#change_address_from_project option').remove();
		$('#change_address_to_project option').remove();
		$('#modal_prepaid_address span.js--modal_subscription_name').html($(this).data('subscription_name'));
		$('#change_address_subscription_id').html($(this).data('subscription_id'));
		var today = new Date();
		var harm = load_harmonogram4medium(
			$(this).data('rate_card_id'),
			(today.toISOString().substring(0, 10) > $(this).data('subscription_from')) ? today.toISOString().substring(0, 10) : $(this).data('subscription_from'),
			$(this).data('subscription_to')
		);
		for (let i = 0; i < harm.length; i++) {
			issue_date = new Date(harm[i]['projectDate']);
			cz_date = issue_date.toLocaleDateString('cz-CS');
			$('#change_address_from_project').append($('<option>', {
				value: harm[i]['projectId'],
				text: (i == 0) ? 'Ihned' : cz_date
			}));

			$('#change_address_to_project').append($('<option>', {
				value: harm[i]['projectId'],
				text: (i == harm.length - 1) ? 'Na stálo' : cz_date
			}));
		}
		opt_count = $('#change_address_to_project option').length;
		$('#change_address_to_project').prop('selectedIndex', opt_count - 1);
	});

	$('#subscription_change_address_submit_button').on('click', function () {
		// validate data
		// submit request
		// close modal
		// show result modal
	});

	// complaint for subscription
	$('.js--check_enable_submit_complaint').on('change', function () {
		// console.log($('#new_delivery_name').val());
		// console.log($('#new_delivery_full_address').val());
		// console.log($('#new_delivery_address_ruian').val());
		can_submit = (
			/*$('#complaint_desc').val() != '' &&*/
			$('#complaint_reason').val() != ''
		);
		if (can_submit) {
			$('#subscription_complaint_submit_button').prop('disabled', false);
		} else {
			$('#subscription_complaint_submit_button').prop('disabled', true);
		}
	});

	$('.js--complaint-subscription').on('click', function (e) {
		e.preventDefault();

		var harm = load_subscription_deliveries(
			$(this).data('subscription_id'), $(this).data('rate_card_id'), $(this).data('subscription_from'), $(this).data('subscription_to')
		);

		if (harm.length == 0) {
			// Otevřít modal s informací o absenci možností
			$('#modal_prepaid_no_options').modal('show');
			return false;
		}

		// Připravit data a otevřít modal
		$('#complaint_issue_project option').remove();
		$('#modal_prepaid_complaint span.js--modal_subscription_name').html($(this).data('subscription_name'));
		$('#complaint_subscription_id').val($(this).data('subscription_id'));

		for (let i = 0; i < harm.length; i++) {
			$('#complaint_issue_project').append($('<option>', {
				value: harm[i]['project_id'],
				text: harm[i]['project_name']
			}));
		}

		// Manuálně otevřít modal
		$('#modal_prepaid_complaint').modal('show');
	});


	$('#subscription_complaint_submit_button').on('click', function () {
		// prepare data
		qry_args = {
			subscription_id: $('#complaint_subscription_id').val(),
			project_id: $('#complaint_issue_project option:selected').val(),
			complaint_reason: $('#complaint_reason option:selected').val(),
			description: $('#complaint_desc').val()
		}

		// submit request
		var req = new XMLHttpRequest();
		req.onreadystatechange = function () {
			if (req.readyState == XMLHttpRequest.DONE) {
				// close modal
				$('#complaint_reason').val('').change();
				$('#complaint_desc').val('');
				$('#modal_prepaid_complaint').modal('hide');
				data = JSON.parse(req.responseText);
				// show result modal
				if (data.status == 200) {
					$('#modal_prepaid_submited').modal('show');
				} else {
					$('#modal_prepaid_submit_failed').modal('show');
				}
			}
		};

		req.open("POST", "/ajax/complaint_prepaid", true);
		req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
		req.send(jQuery.param(qry_args));
		return true;
	});

}
// zaskrtnuti vsech souhlasu objednavky
document.addEventListener('DOMContentLoaded', function () {
	var checkAll = document.querySelector('.js-checkall');
	var consentCheckboxes = document.querySelectorAll('#consents .js--checkbox-alert');

	if (checkAll && consentCheckboxes) {
		checkAll.addEventListener('change', function () {
			consentCheckboxes.forEach(function (checkbox) {
				checkbox.checked = checkAll.checked;
			});
		});

		consentCheckboxes.forEach(function (checkbox) {
			checkbox.addEventListener('change', function () {
				if (!checkbox.checked) {
					checkAll.checked = false;
				} else {
					var allChecked = true;
					consentCheckboxes.forEach(function (cb) {
						if (!cb.checked) {
							allChecked = false;
						}
					});
					checkAll.checked = allChecked;
				}
			});
		});
	}
});

function initializeRemoveAdultContent() {
	$('.js--remove-adult-items').on('click', removeAdultItemsFromCart);
};

function removeAdultItemsFromCart() {
	multi_items = [];
	var adultItemButtons = document.querySelectorAll('button.remove-from-cart[data-adult="True"]');
	adultItemButtons.forEach(function (button) {
		var provider = button.dataset.provider;
		var ident = button.dataset.ident;
		var part = button.dataset.part;
		var contentType = button.dataset.c_type;
		var variant = button.dataset.variant;
		var extend_info = null;
		if (variant) {
			if (!extend_info) {
				extend_info = { "variant": variant };
			}
			else {
				extend_info['variant'] = variant;
			}
		}
		var count = 0;
		refresh = false;

		multi_items.push(create_cart_item(provider, ident, contentType, part, count, extend_info))
	});
	if (multi_items.length > 0) {
		addToCartMultiple(multi_items, false, null, false);
		window.location.reload();
	}
}

function initializeAjaxClearCart() {
	document.querySelectorAll('.js--clear-cart').forEach(function (element) {
		element.addEventListener('click', function (event) {
			event.preventDefault();
			//xhr to /ajax/clear_cart
			var req = new XMLHttpRequest();
			req.onreadystatechange = function () {
				if (req.readyState === 1) {
					document.body.classList.add("loading");
				}
				if (req.readyState == XMLHttpRequest.DONE) {
					if (req.status == 200) {
						//reload page
						window.location.reload();
					}
					else {
						alert("Chyba při vymazání košíku zkuste to prosím znovu.");
						document.body.classList.remove("loading");
					}
				}
			};
			req.open("GET", "/ajax/clear_cart", true);
			req.send();
			return false;
		});
	});
}
